import React from "react";
import Multiselect from "../../../components/common/MultiSelect";
import { useActiveVendors } from "../../../hooks/useVendors";

// Vendor picker for Alliance Manager add executive / field executive pages
const VendorSelect = ({ value, onChange }) => {
  const { vendors: activeVendors, isLoading } = useActiveVendors();

  return (
    <div className="card card-sm card-shadow mb-3">
      <div className="card-body smart-form">
        <div className="row">
          <section className="col col-5">
            <label className="label">
              Vendor<span className="text-danger"> *</span>
            </label>
            <Multiselect
              options={activeVendors}
              value={value}
              onChange={onChange}
              getOptionLabel={(option) => option?.name}
              getOptionValue={(option) => option?.id}
              placeholder="Select Vendor"
              isMulti={false}
              isLoading={isLoading}
            />
          </section>
        </div>
      </div>
    </div>
  );
};

export default VendorSelect;
